export interface UniversityPricingPlan {
  id: string
  name: string
  description: string
  priceLabel: string
  ctaText: string
  features: string[]
  highlightFeature?: string
  highlightMetric?: string
}

export const universityPricingPlans: UniversityPricingPlan[] = [
  {
    id: "basic",
    name: "Department",
    description:
      "For single finance departments looking to improve placement rates",
    priceLabel: "Starting at $99 per student",
    ctaText: "Schedule a Partnership Consultation",
    highlightFeature:
      "15% improvement in finance program rankings within one year",
    features: [
      "AI-powered interview prep for up to 100 students",
      "Dedicated account manager",
      "Basic analytics dashboard",
      "Integration with your LMS",
      "Monthly program effectiveness report",
      "Implementation in under 2 weeks",
    ],
  },
  {
    id: "advanced",
    name: "Business School",
    description:
      "For entire business schools with comprehensive finance programs",
    priceLabel: "Custom pricing for your needs",
    ctaText: "Schedule a Partnership Consultation",
    highlightFeature: "40% increase in student engagement with career services",
    features: [
      "AI-powered interview prep for 100-500 students",
      "Dedicated implementation team",
      "Advanced analytics with real-time insights",
      "LMS integration with SSO capabilities",
      "Weekly program effectiveness reporting",
      "Custom curriculum alignment",
      "Faculty training and workshops",
    ],
  },
  {
    id: "enterprise",
    name: "University-Wide",
    description: "For multi-department implementation across your institution",
    priceLabel: "Enterprise pricing",
    ctaText: "Schedule a Partnership Consultation",
    highlightFeature:
      "30% increase in finance job placements within the first year",
    features: [
      "Unlimited students across departments",
      "Dedicated customer success manager",
      "Enterprise-grade analytics and reporting",
      "Full API access for custom integrations",
      "Customized implementation strategy",
      "White-labeled interface options",
      "On-campus workshops and events",
      "Executive briefings and quarterly reviews",
    ],
  },
]
